/*
 * Public API Surface of neomorphism
 */

export default {};
